import { getCurrencySymbol } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { PageEvent } from "@shared/angular2-datatable/data-table.directive";
import { Channel, ClickarPath, SessionKey } from "@shared/clickar-constants";
import { RatingSelectorComponent } from "@shared/component/rating-selector/rating-selector.component";
import { EmailDialogComponent } from "@shared/dialogs/email-dialog/email-dialog.component";
import { TableData } from "@shared/model/auction.model";
import { Purchase } from "@shared/model/lotDTO";
import { VehicleDTO } from "@shared/model/vehicle.model";
import { EmailData, RatingData } from "@shared/services/alert-message/alert-message.model";
import { ApiService } from "@shared/services/api.service";
import { StorageManagerService } from "@shared/services/storage/storage-manager.service";
import { UsersService } from "@shared/services/users/users.service";
import { ClickarUtilsService } from "@shared/services/utils/clickar-utils.service";
import { WcmService } from "@shared/services/wcm/wcm.service";
import { take } from "rxjs/operators";

@Component({
	selector: "app-shopping-cart",
	templateUrl: "./purchase-summary.component.html",
	styleUrl: "./purchase-summary.component.scss",
	standalone: false
})
export class PurchaseSummaryComponent implements OnInit {
	protected Math = Math;
	protected readonly Channel = Channel;
	protected ClickarPath = ClickarPath;
	protected getCurrencySymbol = getCurrencySymbol;
	private storageService = inject(StorageManagerService);
	protected market: string;

	purchaseHistory: Purchase[] = [];
	filteredPurchaseHistory: Purchase[] = [];

	protected onSingleLevelChange(values: VehicleDTO[] | Purchase[]) { // NOTE: VehicleDTO serve solo per evitare che Typescript rompa le balle
		this.filteredPurchaseHistory = values as Purchase[];
		this.storePaging(this.tableData.mfActivePage = 1);
	}

	rowsOnPageSet = [10, 20, 30];
	tableData: TableData = {
		rowsOnPage: 10,
		orderBy: "datePurchase",
		sortOrder: "desc",
		offset: 30,
		limit: 0,
		col: 21,
		mfActivePage: 1
	};
	showSearch = false;

	constructor(
		public wcmService: WcmService,
		private apiService: ApiService,
		private router: Router,
		private dialog: MatDialog,
		public translate: TranslateService,
		public utils: ClickarUtilsService,
		private userService: UsersService
	) {
		this.tableData.orderBy = this.storageService.getSessionItem(SessionKey.PURCHASE_HISTORY_SORTBY, this.tableData.orderBy || "datePurchase");
		this.tableData.sortOrder = this.storageService.getSessionItem(SessionKey.PURCHASE_HISTORY_SORT_ORDER, this.tableData.sortOrder || "desc");
		Object.assign(this.tableData, this.storageService.getSessionItem(SessionKey.PURCHASE_HISTORY_PAGING, { mfActivePage: this.tableData.mfActivePage ?? 1, rowsOnPage: this.tableData.rowsOnPage ?? 10 }));
	}

	ngOnInit() {
		this.getPurchases()
		this.initMarket()
	}

	initMarket() {
		this.userService.getProfileOfLoggedUser()
			.pipe(take(1))
			.subscribe(user => {
				this.market = user.idMarket;
			});

		/* if (!this.market) {
			const lang = this.translate.getCurrentLang()

			if (lang) {
				this.market = lang.slice(3).toUpperCase();
			}

			this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
				this.market = event.lang.slice(3).toUpperCase();
			});
		} */
	}

	getPurchases() {
		this.apiService.getPurchasesUsingGET()
			.subscribe(value => {
				this.purchaseHistory = value;

				for (const v of this.purchaseHistory) {
					if (this.utils.isNullOrUndefined(v.auctioneerRating) || v.auctioneerRating === 0) {
						v.auctioneerRating = v.numFeedback = 0;
					}
				}
			});
	}

	protected saveOrderBy(attr: string | string[]) { // NOTE: string[] just to keep TS quiet
		this.tableData.orderBy = attr as string; // NOTE: casting just to keep TS quiet
		this.storageService.setSessionItem(SessionKey.PURCHASE_HISTORY_SORTBY, attr);
	}

	protected saveSortOrder(order: "asc" | "desc") {
		this.tableData.sortOrder = order;
		this.storageService.setSessionItem(SessionKey.PURCHASE_HISTORY_SORT_ORDER, order);
	}
	private storePaging = (activePage = this.tableData.mfActivePage, rowsOnPage = this.tableData.rowsOnPage) => {
		this.storageService.setSessionItem(SessionKey.PURCHASE_HISTORY_PAGING, { mfActivePage: activePage, rowsOnPage: rowsOnPage });
	}
	protected savePaging(pageEvent: PageEvent | any) { // Note: any just to satisfy Typescript
		this.storePaging(
			this.tableData.mfActivePage = (pageEvent as PageEvent).activePage,
			this.tableData.rowsOnPage = (pageEvent as PageEvent).rowsOnPage
		);
	}

	toggleCollapseSearch() {
		this.showSearch = !this.showSearch;
	}

	vote(element: any) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.data = new RatingData();
		dialogConfig.data.idAuctioneer = element.idAuctioneer;
		switch (element.channel) {
			case Channel.AUCTION:
				dialogConfig.data.idAuction = element.idAuction;
				break;
			case Channel.SHOWCASE:
				dialogConfig.data.idLot = element.idLot;
		}
		dialogConfig.width = dialogConfig.height = "auto";
		this.dialog.open(RatingSelectorComponent, dialogConfig)
			.afterClosed().subscribe(result => {
				if (result) {
					this.getPurchases()
				}
			});
	}

	awardEmail(element: any) {
		const dialogConfig = new MatDialogConfig(),
			data = new EmailData();

		data.email = element.awardEmail;
		data.recipients = element.recipients;
		data.ccRecipients = element.ccRecipients;
		data.subject = element.subject;
		dialogConfig.data = data;

		dialogConfig.width = dialogConfig.height = "auto";
		this.dialog.open(EmailDialogComponent, dialogConfig);
	}

	goToPresentation(idTemplate: any) {
		this.router.navigate([
			`${ClickarPath.PRIVATE}/${ClickarPath.PARTNER}`,
			{ idTemplate }
		]);
	}

	payByLink(element: any) {
		this.apiService.getLink(element.idPurchase)
			.subscribe(value => {
				window.open(value.link, "_self");
			});
	}
}